import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RatesSalesService {
  private baseUrl = environment.apiNest;

  constructor(
    private http: HttpClient,
    private cognitoService: CognitoService
  ) {}

  // Método para obtener los headers con el token
  private async getHeaders(): Promise<HttpHeaders> {
    const session = await this.cognitoService.getSession();
    if (!session || !session.accessToken || !session.accessToken.jwtToken) {
      return new HttpHeaders().set('Content-Type', 'application/json');
    }

    const token = session.accessToken.jwtToken.trim();
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`);
    return headers;
  }

  async getRatesUsdtSales(currentPage: number, pageSize: number): Promise<any> {
    const headers = await this.getHeaders();
    const serviceURL = `${this.baseUrl}ag-rate-auto/rate-record?page=${currentPage}&pageSize=${pageSize}`;
    return firstValueFrom(this.http.get<any>(serviceURL, { headers }));
  }
}
